<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelEvento"
    :multiple="isMulti"
    :taggable="isTagabble"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    :label="$t('Nome')"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
    :loading="isLoading"
    :hide-selected="hideSelected"
    :close-on-select="closeOnSelect"
  >
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado.') }}</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado.') }}</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ emptyLabel }}</span>
    </template>
    <template slot="tag" slot-scope="{ option }">
      <span class="badge badge-primary mt-1 mb-1">
        <span class="text-truncate mr-1 mb-1">{{
          $moment.out(option.momento_realizacao).format($momentFormat) + ' ' + `${option.nome}`
        }}</span>
        <span class="custom__remove badge" @mousedown.prevent.stop="removeOption(option)">x</span>
      </span>
      <b-icon-info-circle
        class="cursor-pointer mr-3"
        v-b-popover.hover.top="option.grupo_evento__nome_secundario || 'Não informado'"
      />
    </template>
    <template slot="clear" slot-scope="props">
      <div class="multiselect__clear" @mousedown.prevent.stop="clearAll(props.search)"></div>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
import utils from '@/util';
import moment from 'moment';

export default {
  components: {
    Multiselect
  },
  props: {
    nameField: {},
    esporteSelected: {},
    grupoEventoSelected: {},
    isRequired: {},
    isDisabled: {},
    emptyLabel: {},
    isMulti: {},
    isTagabble: {},
    alreadyAdded: {},
    includeAll: {},
    alreadySelected: {},
    showOutright: { type: Boolean, default: true },
    hideSelected: { type: Boolean, default: true },
    closeOnSelect: { type: Boolean, default: true },
    preselectedEvents: { type: Array, default: [] }
  },

  data() {
    return {
      selected: null,
      options: [],
      value: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'evento', null);
        return;
      }
      this.$emit('selectChange', 'evento', e);
    },
    formatSelected(value) {
      let selecteds = [];
      value.forEach((el) => {
        const element = this.options.find((option) => (el?.id ? option.id === el.id : option.id === el));
        if (element) {
          selecteds.push(element);
        }
      });
      return selecteds;
    },
    setValue(value) {
      if (this.isTagabble) {
        this.selected = value;
        this.removeOptions(value);
        this.$emit('input', value);
        this.$emit('selectChange', 'evento', value);
      } else {
        if (value) {
          this.selected = this.options.find((option) => option.id === value.id);
        } else {
          this.selected = this.options.find((option) => option.id === null);
        }
        this.$emit('input', this.selected);
      }
    },
    setOptions({ esporteId, grupoEventoId, preselectedEvents }) {
      this.isLoading = true;
      if (preselectedEvents && preselectedEvents.length > 0) {
        this.options = [...new Set([...this.options, ...preselectedEvents].map(JSON.stringify))]
          .map(JSON.parse)
          .sort((a, b) => a.id - b.id);
        this.setValue(this.nameField);
        this.isLoading = false;
        return;
      }

      let filter = `momento_realizacao >= '${moment().format(
        'YYYY-MM-DD'
      )}' and id_tipo=${esporteId} and cache.evento.bloqueado IS NOT TRUE`;
      if (grupoEventoId)
        filter += ` and id_grupo_evento=${grupoEventoId} and cache.grupo_evento.bloqueado IS NOT TRUE`;
      if (this.alreadySelected) {
        filter = `evento.id = ${this.alreadySelected}`;
      }
      if (!this.showOutright) {
        filter += ` AND evento.outright IS NOT TRUE`;
      }

      this.$atenaList
        .getEventos({
          columns: '*',
          filter: filter,
          related: 'grupo_evento:nome_secundario,id as id_grupo_evento',
          order: 'momento_realizacao'
        })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);
          if (this.alreadyAdded) {
            this.removeOptions(this.alreadyAdded);
          }
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    },
    labelEvento({ nome, momento_realizacao }) {
      return this.$moment.out(momento_realizacao).format(this.$momentFormat) + ' ' + `${nome}`;
    },
    clearAll() {
      this.value = [];
    },
    removeOptions(options) {
      if (!options) {
        return;
      }
      let opt = [];
      this.options.forEach((element) => {
        const el = options.find((el) => el.id === element.id);
        if (!el) opt.push(element);
      });
      this.options = opt;
    },
    removeOption(option) {
      if (!option) return;
      let valueCp = [];
      this.selected.forEach((element) => {
        const el = this.selected.find((el) => el.id === option.id);
        if (el) {
          valueCp = this.selected.filter((elem) => elem.id != el.id);
        }
      });
      this.setValue(valueCp);
      this.options = [option, ...this.options];
    }
  },

  watch: {
    grupoEventoSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions({ esporteId: this.esporteSelected, grupoEventoId: newVal });
        !this.selected ? this.onChange() : null;
      }
    },
    nameField: function (value) {
      if (!value) {
        this.setOptions({ esporteId: this.esporteSelected, grupoEventoId: this.grupoEventoSelected });
      } else {
        this.setValue(value);
      }
    },
    esporteSelected(value) {
      this.setOptions({ esporteId: value, grupoEventoId: this.grupoEventoSelected });
    },
    preselectedEvents(value) {
      this.setValue(value);
    }
  },

  created() {
    if (this.esporteSelected || this.preselectedEvents)
      this.setOptions({
        esporteId: this.esporteSelected,
        grupoEventoId: this.grupoEventoSelected,
        preselectedEvents: this.preselectedEvents
      });
  }
};
</script>

<style lang="scss" scoped>
.custom__remove {
  background: #26b4ff !important;
  color: #fff;
  transition: ease 0.2s all;
}

.custom__remove:hover {
  cursor: pointer;
  background: #0097e9 !important;
}
</style>
